// draftBubbleOverlay — pure position math for the "作成中バブル"
// (custom-cursor-2026-09-19.md §2.5-4, time-permitting bonus): while a peer
// is editing their cursor (`member.cursor-draft`), show a small live-preview
// speech bubble at their LAST KNOWN stroke position on the canvas
// ("キャンバス上でカーソルが生まれていく" — the person is typically NOT
// drawing while in the editor, so this must survive past the 1s NameLabel
// TTL; see `useLastKnownStrokePosition.ts` which is what actually persists
// the position across TTL expiry).
//
// Kept as a separate pure module (same rationale as
// `computeNameLabelPosition` in `NameLabelOverlay.tsx`): node-env testable,
// no React/DOM.

import { canvasToLocalByZoomFlip } from '../../../infrastructure/drawing/viewport.js';

/** Canvas-native (x, y) — the last point a peer's stroke was observed at. */
export interface LastKnownPosition {
  readonly x: number;
  readonly y: number;
}

/** Small fixed offset so the bubble sits above-left of the point, not on top of it. */
export const DRAFT_BUBBLE_OFFSET_X_PX = 28;
export const DRAFT_BUBBLE_OFFSET_Y_PX = 28;

export const computeDraftBubblePosition = (
  pos: LastKnownPosition,
  zoom: number,
  flipX = false,
  canvasWidth?: number,
): { left: number; top: number } => {
  // 変換は viewport.ts §1b (canvas → wrapper-local) に集約済み。
  const p = canvasToLocalByZoomFlip(pos.x, pos.y, zoom, flipX, canvasWidth);
  return {
    left: Math.max(0, p.x - DRAFT_BUBBLE_OFFSET_X_PX),
    top: Math.max(0, p.y - DRAFT_BUBBLE_OFFSET_Y_PX),
  };
};
